import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {HoverStyles, TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import {useAppActions} from '../../../../hooks/runtime'
import {TicketIcon} from '../../../common/icons'
import {classes} from './accessibility-mode-button.st.css'

export const AccessibilityModeButton = () => {
  const {t} = useTranslation()
  const {setShowAccessibilityMode} = useAppActions()

  return (
    <div className={classes.accessibilityModeContainer}>
      <TextButton
        className={classes.textButton}
        data-hook={DH.ACCESSIBILITY_MODE_BUTTON}
        priority={TextButtonPriority.secondary}
        hoverStyle={HoverStyles.underline}
        prefixIcon={<TicketIcon />}
        onClick={() => setShowAccessibilityMode(true)}
      >
        {t('seatings_selectFromList')}
      </TextButton>
    </div>
  )
}
